export enum Level {
    ihunterSuperUser = 1,
    ihunterAdmin = 2,
    ihunterReportes = 3,
    CompanyAdmin = 4,
    CompanyUser = 5,
    CompanyReportes = 6,
    Broker = 7
}